import { render, staticRenderFns } from "./BatchRunComponentTable.vue?vue&type=template&id=cf936134&scoped=true"
import script from "./BatchRunComponentTable.vue?vue&type=script&lang=js"
export * from "./BatchRunComponentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf936134",
  null
  
)

export default component.exports